import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { supabase } from '../../services/supabaseClient/supabaseClient';
import AuthLayout from '../../components/Auth/authLayout';
import FancyButton from '../../components/ui/fancyButton';

const UpdatePassword = () => {
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);

    if (params.get('error')) {
      const errorDescription = params.get('error_description') || 'Unknown error.';
      setMessage(`❌ ${errorDescription}`);
    } else {
      // Supabase will automatically set the session if the link is valid
      setIsVerified(true);
    }
  }, []);

  const handleUpdate = async () => {
    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setMessage(`❌ ${error.message}`);
    } else {
      setMessage('✅ Password updated successfully! Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    }
  };

  return (
    <AuthLayout title="Set New Password">
      {!isVerified ? (
        <p>{message || '⏳ Verifying link...'}</p>
      ) : (
        <>
          <input
            type="password"
            placeholder="Enter your new password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <FancyButton variant="primary" onClick={handleUpdate}>
            Update Password
          </FancyButton>
          {message && <p>{message}</p>}
        </>
      )}
    </AuthLayout>
  );
};

export default UpdatePassword;
